import { EffectCallback, useEffect } from 'react';

// This is essentially a `useEffect` that only gets called when the component first mounts.
export const useOnMount = (action: EffectCallback) => useEffect(action, []); // eslint-disable-line react-hooks/exhaustive-deps
